<template>
  <v-container class="home-page">
    <div>
      <div class="bg-fixed-100" :style="{ backgroundImage: 'url(' + homepageBg + ')' }"></div>
      <div class="bg-fixed-100 train"></div>
      <div v-if="$root.loggedIn" class="bg-fixed-100 foreground" :style="{ backgroundImage: 'url(' + homepageFg + ')' }"></div>

      <img :src="$root.logoYellow" class="main-logo big">

      <div v-if="$root.loggedIn">
        <div
          v-for="(collection, index) in $root.config.collectionwomen24"
          :key="'product' + index"
          class="product"
          :style="{ top: collection.py + '%', left:collection.px + '%'}"
          @click="openCollection(collection.categoryslug)">
            <div class="red-bg"></div>
            <h5 class="font-kristi">{{collection.category}}</h5>
        </div>
      </div>
      <div v-else class="home-comingsoon ">
        <h5 class="font-jost bold">PASSWORD:</h5>
        <input type="password" v-model="password">
      </div>

      <Clock :archive="true" :newroute="'WomenArchive'"></Clock>
    </div>
  </v-container>
</template>

<script>
import Clock from '../atoms/Clock.vue'

import Viewport from '@monogrid/vue-lib/lib/mixins/Viewport'
import homepageBg from '@/assets/img/homepage-bg.jpg'
import homepageFg from '@/assets/img/homepage-foreground-nov-2024.png'

export default {
  name: 'Home',

  mixins: [Viewport],

  components: {
    Clock
  },

  data () {
    return {
      password: '',
      homepageBg,
      homepageFg
    }
  },
  mounted () {
    // console.log(this.$root.config)
    this.$root.introSeen = true

    if (window.location.hostname.indexOf('localhost') > -1) {
      this.$root.loggedIn = true
    }
  },

  methods: {
    openCollection (cat) {
      this.$router.push({
        name: 'Collection',
        params: {
          collection: cat.toLowerCase()
        }
      })
    }
  },

  watch: {
    password: function (value) {
      if (value === 'choochoo') {
        this.$root.loggedIn = true
      }
    }
  },

  metaInfo: function () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.train {
  background-image: url('../assets/img/homepage-fg.png');
  background-repeat: repeat-x;
  background-size: cover;
  animation: slide 30s linear infinite;
}

@keyframes slide {
  from { background-position: 0 0; }
  to { background-position: -1920px 0; }
}

.home-header {
  position: absolute;
  top: 30%;
  left: 0;
  display: inline-block;
  transform: translateX(-50%);
  z-index: 2;
}

.home-comingsoon {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translateX(-50%);
  color: $c-red;
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;

  input {
    border: 1px solid #000;
  }
}

.product {
  position: absolute;
  padding: 10px;
  width: fit-content;
  height: fit-content;
  color: #fff;
  transform: translateX(-50%) rotate(-15deg);
  cursor: pointer;
}
</style>
